import styled from "styled-components";

export const Container = styled.div`
  position: absolute;
  right: 0;
  top: 56px;
  z-index: 1;
  background: #fff;
  bottom: 0;
  width: 307px;
  max-height: calc(100vh - 59px);

  .header {
    display: flex;
    padding: 10px 22px;
    background: #000000;
    justify-content: space-between;
    align-items: center;
    h4 {
      font-size: 24px;
      color: #ffffff;
      line-height: 150.5%;
      font-weight: 400;
    }
    img {
      cursor: pointer;
    }
  }
  @media (max-width: 550px) {
    width: 100%;
  }
`;

export const SearchWrapper = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  width: calc(100% - 40px);
  margin: 0 auto;
  padding: 16px 0;
  border-bottom: 1px solid #cdcfd066;

  input {
    background: #ffffff;
    border: 1px solid #cdcfd0;
    border-radius: 6px;
    padding-left: 10px;
    min-height: 30px;
    width: 100%;
  }
  img {
    position: absolute;
    right: 8px;
  }
`;

export const CarContainer = styled.div`
  padding: 14px 12px;
  height: calc(100% - 135px);
  overflow: auto;
`;

export const WrapperCar = styled.div`
  display: flex;
  align-items: flex-start;
  width: 100%;
  gap: 38px 29px;
  flex-wrap: wrap;
  height: auto;
  align-items: flex-start;
`;
